import { FormattedMessage } from '@subaio/components'

import { asContainer } from 'lib/container'

import { IconHeaderError } from 'components/Icons'
import { SplashScreen } from 'components/Layout'

export const container = asContainer<{}>()({
	authentication: { type: 'public' },
	Running: () => (
		<SplashScreen
			title={
				<FormattedMessage
					id='notAuthenticated.title'
					defaultMessage='You must be logged in to access her page. Please use the link you have been given to log in.'
				/>
			}
			icon={<IconHeaderError />}
		/>
	),
})
